import { allergiesMap } from "./allergies";
import { timestampsMap } from "./timestamps";
import { unitMap } from "./unit";

export const patientMap: GenericObject = {
	id: "id",
	nome: "name",
	name_mother: "nameMother",
	sexo: "sex",
	raca_cor: "race",
	cpf: "identifier",
	cns: "nationalHealthCard",
	uf: "state",
	cep: "zipCode",
	cidade: "city",
	bairro: "neighborhood",
	data_formatada: "formattedBirthdate",
	idade_carbon: "carbonAge",
	allergies: allergiesMap,
	logradouro: "address",
	numero: "number",
	celular: "phone",
	celular_contato: "secondaryPhone",
	unit: unitMap,
	...timestampsMap,
};
